const getWeekNumber = (date, iso8601) => {
  if (!date)
    return null;
  const day = (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getDate();
  const month = (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getMonth();
  const year = (/* @__PURE__ */ new Date(`${date}T00:00:00`)).getFullYear();
  const currentDate = new Date(year, month, day);
  const dayNum = iso8601 ? currentDate.getDay() || 7 : currentDate.getDay();
  currentDate.setDate(currentDate.getDate() + 4 - dayNum);
  const yearStart = new Date(currentDate.getFullYear(), 0, 1);
  const weekNumber = Math.ceil(((+currentDate - +yearStart) / 864e5 + 1) / 7);
  return {
    year,
    week: weekNumber
  };
};
export {
  getWeekNumber as default
};
